import { createAction } from 'redux-actions'

const ns = 'signUpCodeAdmin/'

// Fetch sign-up codes for a company
export const getCompanySignUpCodes = createAction(`${ns}GET_COMPANY_SIGN_UP_CODES`)
export const getCompanySignUpCodesSuccess = createAction(`${ns}GET_COMPANY_SIGN_UP_CODES_SUCCESS`)
export const getCompanySignUpCodesFail = createAction(`${ns}GET_COMPANY_SIGN_UP_CODES_FAIL`)

// Create a new sign-up code
export const createCompanySignUpCode = createAction(`${ns}CREATE_COMPANY_SIGN_UP_CODE`)
export const createCompanySignUpCodeSuccess = createAction(`${ns}CREATE_COMPANY_SIGN_UP_CODE_SUCCESS`)
export const createCompanySignUpCodeFail = createAction(`${ns}CREATE_COMPANY_SIGN_UP_CODE_FAIL`)

// Update a sign-up code
export const updateCompanySignUpCode = createAction(`${ns}UPDATE_COMPANY_SIGN_UP_CODE`)
export const updateCompanySignUpCodeSuccess = createAction(`${ns}UPDATE_COMPANY_SIGN_UP_CODE_SUCCESS`)
export const updateCompanySignUpCodeFail = createAction(`${ns}UPDATE_COMPANY_SIGN_UP_CODE_FAIL`)

// Delete a sign-up code
export const deleteCompanySignUpCode = createAction(`${ns}DELETE_COMPANY_SIGN_UP_CODE`)
export const deleteCompanySignUpCodeSuccess = createAction(`${ns}DELETE_COMPANY_SIGN_UP_CODE_SUCCESS`)
export const deleteCompanySignUpCodeFail = createAction(`${ns}DELETE_COMPANY_SIGN_UP_CODE_FAIL`)
